module.exports = __webpack_public_path__ + "static/media/068-girl-8.4d6f8b8c.svg";